var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"margin":"0"},attrs:{"text":"","icon":"","dark":""},on:{"click":function($event){return _vm.onSelectInterventionLevel(_vm.itm)}}},[_c('v-icon',{staticClass:"square",style:({ background: _vm.params.data.color })})],1)}
var staticRenderFns = []

export { render, staticRenderFns }